import type { Membership } from '@space-shell/common/services/membership/types'
import type { UserInfo } from '@space-shell/common/services/user'
import type { UserInfoRole } from '@space-shell/common/services/user/types'

export type UserStoreType = {
  user: UserInfo
  setUser: (user: UserInfo) => void
}

export type AuthStoreType = {
  token: string
  locale: string
  userName: string
  userSocialName: string
  baseUrl: string
  id: string
  authorities: string[]
  expires_at: number
  tokenCreatedAt: number
  ucode: string
  sid: string
  email: string
  setAuth: (auth: AuthType) => void
  resetAuth: () => void
}

export type MembershipStoreType = {
  membershipSlug: string
  membershipData?: Membership
  setMembershipSlug: (membershipSlug: string) => void
  setMembershipData: (membershipData: Membership) => void
}

export type AuthType = Pick<
  AuthStoreType,
  | 'token'
  | 'locale'
  | 'userName'
  | 'userSocialName'
  | 'baseUrl'
  | 'id'
  | 'authorities'
  | 'expires_at'
  | 'tokenCreatedAt'
  | 'ucode'
  | 'sid'
  | 'email'
>

export type UserInfoStoreType = {
  role: UserInfoRole
  name?: string
  avatar?: string
  email?: string
  isAttendant?: boolean
  isMembership?: boolean
  setUserInfo: (userInfo: UserInfoType) => void
  resetUserInfo: () => void
}

export type UserInfoType = Pick<
  UserInfoStoreType,
  'role' | 'name' | 'avatar' | 'email' | 'isAttendant' | 'isMembership'
>

export enum ViewAsFromPageType {
  Home = 'HomePage',
  EditProduct = 'EditProductPage',
  ListProducts = 'ListProductsPage'
}

export enum RoleType {
  Creator = 'Creator',
  Member = 'Member',
  UserNoAccess = 'UserNoAccess',
  UserLogout = 'UserLogout'
}

export const DEFAULT_ROLE_TYPE: RoleType = RoleType.Creator

export type ViewAsBaseType = {
  isEnabled: boolean
  from: ViewAsFromPageType
}

export type ClassItemType = {
  hash: string
  defaultClass: boolean
  name?: string
}

export type ViewAsStoreType = {
  isEnabled: boolean
  from: ViewAsFromPageType
  role: RoleType
  isReadonly?: boolean
  classItem?: ClassItemType
}
